import type { ThesisBrief } from './types'

export type BriefGap = { field: string; label: string; hint: string }

/** 开题卡「可进入分章正文」的最低完备度——真实论证所需，不是填空游戏 */
export function assessBriefReadiness(brief: ThesisBrief): {
  ready: boolean
  score: number
  gaps: BriefGap[]
} {
  const gaps: BriefGap[] = []
  const need = (ok: boolean, field: string, label: string, hint: string) => {
    if (!ok) gaps.push({ field, label, hint })
  }

  need(
    brief.practiceBackground.trim().length >= 20,
    'practiceBackground',
    '实践背景',
    '至少交代行业/企业/岗位情境（建议 20 字以上）',
  )
  need(
    brief.problemStatement.trim().length >= 15,
    'problemStatement',
    '管理痛点',
    '写可观察的痛点，避免「数字化很重要」式空话',
  )
  need(brief.researchPurpose.trim().length >= 8, 'researchPurpose', '研究目的', '一句话说明本研究要达成什么')
  const rqs = brief.researchQuestions.map((q) => q.trim()).filter(Boolean)
  need(rqs.length >= 1, 'researchQuestions', '研究问题', '至少一条可操作的核心 RQ')
  need(brief.theoreticalLens.trim().length >= 4, 'theoreticalLens', '理论视角', '选定主理论/镜头')
  const constructs = brief.keyConstructs.filter((c) => c.name.trim() && c.definition.trim())
  need(constructs.length >= 1, 'keyConstructs', '关键构念', '至少一个构念含名称与定义')
  need(brief.analysisFramework.trim().length >= 15, 'analysisFramework', '分析框架', '说明构念如何串成可分析逻辑')
  need(!!brief.methodType.trim(), 'methodType', '研究方法', '选择方法类型')
  need(brief.caseOrSample.trim().length >= 4, 'caseOrSample', '案例/样本', '界定分析对象')
  need(brief.dataSources.filter((d) => d.trim()).length >= 1, 'dataSources', '数据来源', '至少一类数据来源')
  need(brief.scopeOut.trim().length >= 8, 'scopeOut', '研究边界（不写什么）', '明确排除项是防跑偏的关键')

  const required = 11
  const score = Math.round(((required - gaps.length) / required) * 100)
  return { ready: gaps.length === 0, score, gaps }
}

export function deriveStage(brief: ThesisBrief): ThesisBrief['stage'] {
  const { ready } = assessBriefReadiness(brief)
  if (!ready) return 'briefing'
  const gates = Object.values(brief.chapterGates)
  if (gates.every((g) => g.status === 'passed')) return 'done'
  if (gates.some((g) => g.status === 'needs_revision' || g.status === 'review')) return 'revising'
  if (gates.some((g) => g.status === 'drafting' || g.status === 'passed' || g.status === 'open')) {
    return 'drafting'
  }
  return 'outlining'
}
